export const INITIAL = {
	TAB: 0,
	VALUES: {},
}
